module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params.isActive) ? _c('ModalDefault', {
    attrs: {
      "size": "s",
      "with-content": true,
      "theme": true,
      "fix-height": false,
      "fix-width": false,
      "loading": false
    },
    on: {
      "close": function($event) {
        _vm.no();
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t("common.upload")))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("catalogForecast.market.warningUpload")))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive my-4"
  }, [_c('table', _vm._l((_vm.params.uploads), function(upload) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(upload.by.firstname + " " + upload.by.lastname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.moment(upload.date).format(_vm.$t("common.dateTimeFormat"))))])])
  }))]), _vm._v(" "), _c('p', {
    staticClass: "waring-2"
  }, [_vm._v(_vm._s(_vm.$t("catalogForecast.market.warningUpload2")))]), _vm._v(" "), _c('p', {
    staticClass: "waring-3"
  }, [_vm._v(_vm._s(_vm.$t("catalogForecast.market.warningUpload3")))]), _vm._v(" "), _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col d-flex justify-content-center"
  }, [_c('ClientColorButton', {
    staticClass: "mr-4",
    attrs: {
      "inactiveColor": true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.no();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("wishlist.btNo")) + " ")]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "background-color": _vm.currentBrand.linksColor
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.yes();
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("wishlist.btYes")) + "\n                ")])], 1)])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0663641c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalogForcast/elements/UploadInfos.vue
// module id = 2989
// module chunks = 0